import React from "react";
import ReactDOM from "react-dom/client"; // <-- updated import
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { store } from "./config/store";
import {
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from "react-redux-i18n";
import labeli18n from "./i18n/labeli18n";
import { PrimeReactProvider } from "primereact/api";
syncTranslationWithStore(store);
store.dispatch(loadTranslations(labeli18n));
store.dispatch(setLocale("es"));

const rootComponent = (
  <PrimeReactProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </PrimeReactProvider>
);

// Updated for React 18+
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(rootComponent);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
